import styled, { css } from 'styled-components';
import { field } from '../../utils/css';

const secondary = css`
  border: none;
  background-color: #efefef;
  height: 40px;
`;

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 2.5rem;

  input.form-control {
    ${field};
    font-size: 1rem;
    padding-right: 40px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid
      ${(props) =>
        props.error
          ? props.theme.field.errorBorderColor || '#dc3545'
          : props.focus
            ? props.theme.field.focusBorderColor || '#80bdff'
            : props.theme.field.borderColor || '#ced4da'};
    border-radius: 0rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
    height: calc(1.5em + 0.75rem + 20px);
    padding: 0.375rem 0.75rem;

    &:focus {
      border-color: ${(props) =>
        props.theme.field.focusBorderColor || '#80bdff'};
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &.is-invalid {
      border-color: ${(props) =>
        props.theme.field.errorBorderColor || '#dc3545'};
    }

    ${(props) => props.secondary && secondary};

    @media (min-width: 576px) {
      ${(props) => props.noBorder && 'border: none;'}
    }
  }

  .error-message {
    position: absolute;
    bottom: -1.25rem;
    left: 0;
    color: ${(props) => props.theme.field.errorBorderColor || '#dc3545'};
    font-size: 0.875rem;
    line-height: 1.2;
  }
`;

export default Wrapper;
